import * as yup from "yup";

export const createUserSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  fullName: yup.string().required("Full Name is required"),
  username: yup.string().optional(),
  phone: yup.string().optional(),
  location: yup.string().optional(),
  whatsappNo: yup.string().optional(),
  // Not collected by the form — the API applies the users.role column default.
  // Plain string (not oneOf) so openCreate's "" seed still validates.
  role: yup.string().optional(),
  isActive: yup.boolean().default(true),
  preferredCurrency: yup.string().optional(),
  accountType: yup
    .string()
    .oneOf(["personal", "broker", "company"])
    .required("Account type is required"),
  markVerified: yup.boolean().default(false),
  companyName: yup.string().when("accountType", {
    is: "company",
    then: (s) => s.required("Company name is required"),
    otherwise: (s) => s.optional(),
  }),
  companyTradingName: yup.string().optional(),
  companyBio: yup.string().optional(),
  companyId: yup.string().optional(),
});

export const updateUserSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  fullName: yup.string().required("Full Name is required"),
  username: yup.string().optional(),
  phone: yup.string().optional(),
  location: yup.string().optional(),
  whatsappNo: yup.string().optional(),
  role: yup.string().optional(),
  isActive: yup.boolean().default(true),
  preferredCurrency: yup.string().optional(),
  accountType: yup.string().oneOf(["personal", "broker", "company"]).optional(),
  companyId: yup.string().optional(),
});
